import DashboardTasks from "src/views/authenticated/tasks/TasksView";
import DashboardCreateTaskView from "src/views/authenticated/tasks/create/CreateTaskView";
import DashboardTasksCompleted from "src/views/authenticated/tasks/TasksCompletedView";
import CreateTaskModal from "src/views/authenticated/tasks/create/CreateTaskModal";
import { Route } from "react-router-dom";
import ProtectedRoute from "src/routes/middlewares/ProtectedRoute";
import TaskModal from "src/components/forms/TaskForm/modals/task-modal/TaskModal";
import TasksFilterView from "src/views/authenticated/tasks/TasksFilterView";
import TasksDetailView from "src/views/authenticated/tasks/detail";

const TasksRoutes = [
	<Route
		element={
			<ProtectedRoute>
				<DashboardTasks />
			</ProtectedRoute>
		}
		path="/tasks"
		key="/tasks"
	/>,
	<Route
		element={
			<ProtectedRoute>
				<DashboardTasks />
			</ProtectedRoute>
		}
		path="/tasks/teams/:team"
		key="/tasks/teams/:team"
	/>,
	<Route
		element={
			<ProtectedRoute type="company">
				<DashboardCreateTaskView />
			</ProtectedRoute>
		}
		path="/tasks/create"
		key="/tasks/create"
	/>,
	<Route
		element={
			<ProtectedRoute type="company">
				<DashboardTasksCompleted />
			</ProtectedRoute>
		}
		path="/tasks/create/completed/thanks"
		key="/tasks/create/completed/thanks"
	/>,

	<Route
		element={
			<ProtectedRoute>
				<TasksDetailView />
			</ProtectedRoute>
		}
		path="/tasks/:id/:pane/:registration?/:extra?"
		key="/tasks/:id/:pane/:registration?/:extra?"
	/>,
];

export const TasksModalRoutes = [
	<Route
		element={
			<ProtectedRoute
				variant="modal"
				modal={{
					backUrl: "/tasks",
					expanded: false,
					size: "default",
				}}
			>
				<TasksFilterView />
			</ProtectedRoute>
		}
		path="/tasks/filter"
		key="/tasks/filter"
	/>,
	<Route
		element={
			<ProtectedRoute
				variant="modal"
				modal={{
					backUrl: "/tasks",
					expanded: false,
					size: "medium",
				}}
			>
				<CreateTaskModal />
			</ProtectedRoute>
		}
		path="/tasks/:id/create"
		key="/tasks/:id/create"
	/>,
	<Route
		element={
			<ProtectedRoute variant="on-top">
				<TaskModal defaultVisible backUrl="/tasks" />
			</ProtectedRoute>
		}
		path="/tasks/:id/show"
		key="/tasks/:id/show"
	/>,
	// <Route
	// 	element={
	// 		<ProtectedRoute
	// 			variant="modal"
	// 			modal={{
	// 				backUrl: "/tasks",
	// 				expanded: false,
	// 				size: "medium",
	// 			}}
	// 		>
	// 			<CreateTaskModal />
	// 		</ProtectedRoute>
	// 	}
	// 	path="/tasks/:id/show/publish"
	// 	key="/tasks/:id/show/publish"
	// />,
];

export default TasksRoutes;
